import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../chunks/tslib.es6.js";
import t from "../config.js";
import { id as r } from "../kernel.js";
import o from "../request.js";
import { deprecatedProperty as s, deprecatedFunction as i } from "../core/deprecate.js";
import a from "../core/Error.js";
import { JSONSupportMixin as l } from "../core/JSONSupport.js";
import n from "../core/Loadable.js";
import u from "../core/Logger.js";
import { isSome as p } from "../core/maybe.js";
import { throwIfAborted as d, isAborted as h, createAbortError as c, throwIfAbortError as y } from "../core/promiseUtils.js";
import { property as m } from "../core/accessorSupport/decorators/property.js";
import "../core/arrayUtils.js";
import "../core/has.js";
import { ensureType as v } from "../core/accessorSupport/ensureType.js";
import { reader as f } from "../core/accessorSupport/decorators/reader.js";
import { subclass as S } from "../core/accessorSupport/decorators/subclass.js";
import g from "../geometry/Extent.js";
import { getLocale as P } from "../intl/locale.js";
import _ from "./PortalQueryParams.js";
import G from "./PortalQueryResult.js";
import O from "./PortalUser.js";
import { supportsApiKey as U } from "../support/apiKeyUtils.js";

var _w;

var j;
var Q = {
  PortalGroup: function PortalGroup() {
    return import("./PortalGroup.js");
  },
  PortalItem: function PortalItem() {
    return import("./PortalItem.js");
  },
  PortalUser: function PortalUser() {
    return import("./PortalUser.js");
  }
};

var C = _w = /*#__PURE__*/function (_l) {
  _inherits(w, _l);

  var _super = _createSuper(w);

  function w(e) {
    var _this;

    _classCallCheck(this, w);

    _this = _super.call(this, e), _this.access = null, _this.allSSL = !1, _this.authMode = "auto", _this.authorizedCrossOriginDomains = null, _this.basemapGalleryGroupQuery = null, _this.bingKey = null, _this.canListApps = !1, _this.canListData = !1, _this.canListPreProvisionedItems = !1, _this.canProvisionDirectPurchase = !1, _this.canSearchPublic = !0, _this.canShareBingPublic = !1, _this.canSharePublic = !1, _this.canSignInArcGIS = !1, _this.canSignInIDP = !1, _this.colorSetsGroupQuery = null, _this.commentsEnabled = !1, _this.created = null, _this.culture = null, _this.customBaseUrl = null, _this.defaultBasemap = null, _this.defaultDevBasemap = null, _this.defaultExtent = null, _this.defaultVectorBasemap = null, _this.description = null, _this.devBasemapGalleryGroupQuery = null, _this.eueiEnabled = null, _this.featuredGroups = null, _this.featuredItemsGroupQuery = null, _this.galleryTemplatesGroupQuery = null, _this.livingAtlasGroupQuery = null, _this.hasCategorySchema = !1, _this.helperServices = null, _this.homePageFeaturedContent = null, _this.homePageFeaturedContentCount = null, _this.httpPort = null, _this.httpsPort = null, _this.id = null, _this.ipCntryCode = null, _this.isPortal = !1, _this.isReadOnly = !1, _this.layerTemplatesGroupQuery = null, _this.maxTokenExpirationMinutes = null, _this.modified = null, _this.name = null, _this.portalHostname = null, _this.portalMode = null, _this.portalProperties = null, _this.region = null, _this.rotatorPanels = null, _this.showHomePageDescription = !1, _this.sourceJSON = null, _this.supportsHostedServices = !1, _this.symbolSetsGroupQuery = null, _this.templatesGroupQuery = null, _this.units = null, _this.url = t.portalUrl, _this.urlKey = null, _this.user = null, _this.useStandardizedQuery = !1, _this.useVectorBasemaps = !1, _this.vectorBasemapGalleryGroupQuery = null;
    return _this;
  }

  _createClass(w, [{
    key: "normalizeCtorArgs",
    value: function normalizeCtorArgs(e) {
      return "string" == typeof e ? {
        url: e
      } : e;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._esriId_credentialCreateHandle && (this._esriId_credentialCreateHandle.remove(), this._esriId_credentialCreateHandle = null);
    }
  }, {
    key: "readAuthorizedCrossOriginDomains",
    value: function readAuthorizedCrossOriginDomains(e) {
      if (e) {
        var _iterator = _createForOfIteratorHelper(e),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _r = _step.value;
            -1 === t.request.trustedServers.indexOf(_r) && t.request.trustedServers.push(_r);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      return e;
    }
  }, {
    key: "readDefaultBasemap",
    value: function readDefaultBasemap(e) {
      return this._readBasemap(e);
    }
  }, {
    key: "readDefaultDevBasemap",
    value: function readDefaultDevBasemap(e) {
      return this._readBasemap(e);
    }
  }, {
    key: "readDefaultVectorBasemap",
    value: function readDefaultVectorBasemap(e) {
      return this._readBasemap(e);
    }
  }, {
    key: "extraQuery",
    get: function get() {
      var e = !(this.user && this.user.orgId) || this.canSearchPublic;
      return this.id && !e ? " AND orgid:".concat(this.id) : null;
    }
  }, {
    key: "isOrganization",
    get: function get() {
      return !!this.access;
    }
  }, {
    key: "restUrl",
    get: function get() {
      var e = this.url;

      if (e) {
        var _t = e.indexOf("/sharing");

        e = _t > 0 ? e.substring(0, _t) : this.url.replace(/\/+$/, ""), e += "/sharing/rest";
      }

      return e;
    }
  }, {
    key: "stylesGroupQuery",
    get: function get() {
      return s(u.getLogger(this.declaredClass), "stylesGroupQuery", {
        replacement: "stylesGroupQuery3d",
        version: "4.21"
      }), this.stylesGroupQuery3d;
    }
  }, {
    key: "thumbnailUrl",
    get: function get() {
      var e = this.restUrl,
          t = this.thumbnail;
      return e && t ? this._normalizeSSL(e + "/portals/self/resources/" + t) : null;
    }
  }, {
    key: "readUrlKey",
    value: function readUrlKey(e) {
      return e ? e.toLowerCase() : e;
    }
  }, {
    key: "readUser",
    value: function readUser(e) {
      var t = null;
      return e && (t = O.fromJSON(e), t.portal = this), t;
    }
  }, {
    key: "load",
    value: function load(e) {
      var _this2 = this;

      var t = import("../Basemap.js").then(function (_ref) {
        var t = _ref.default;
        d(e), j = t;
      }).then(function () {
        return _this2.sourceJSON ? _this2.sourceJSON : _this2._fetchSelf(_this2.authMode, !1, e);
      }).then(function (e) {
        if (r) {
          var _e = r;
          _this2.credential = _e.findCredential(_this2.restUrl), _this2.credential || _this2.authMode !== _w.AUTH_MODE_AUTO || (_this2._esriId_credentialCreateHandle = _e.on("credential-create", function () {
            _e.findCredential(_this2.restUrl) && _this2._signIn();
          }));
        }

        _this2.sourceJSON = e, _this2.read(e);
      });
      return this.addResolvingPromise(t), Promise.resolve(this);
    }
  }, {
    key: "createClosestFacilityTask",
    value: function () {
      var _createClosestFacilityTask = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var e;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                i(u.getLogger(this.declaredClass), null, {
                  replacement: "Use helperServices url with esri/rest/closestFacility",
                  version: "4.21"
                });
                _context.next = 3;
                return this.load();

              case 3:
                e = this._getHelperServiceUrl("closestFacility");
                0;
                _context.next = 7;
                return import("../tasks/ClosestFacilityTask.js");

              case 7:
                _context.t0 = _context.sent.default;
                _context.t1 = e;
                return _context.abrupt("return", new _context.t0(_context.t1));

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function createClosestFacilityTask() {
        return _createClosestFacilityTask.apply(this, arguments);
      }

      return createClosestFacilityTask;
    }()
  }, {
    key: "createElevationLayers",
    value: function () {
      var _createElevationLayers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var e, t;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.load();

              case 2:
                e = this._getHelperService("defaultElevationLayers");
                _context2.next = 5;
                return import("../layers/ElevationLayer.js");

              case 5:
                t = _context2.sent.default;
                return _context2.abrupt("return", e ? e.map(function (e) {
                  return new t({
                    id: e.id,
                    url: e.url
                  });
                }) : []);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function createElevationLayers() {
        return _createElevationLayers.apply(this, arguments);
      }

      return createElevationLayers;
    }()
  }, {
    key: "createGeometryService",
    value: function () {
      var _createGeometryService = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var e;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                i(u.getLogger(this.declaredClass), null, {
                  replacement: "Use helperServices url with esri/rest/geometryService",
                  version: "4.21"
                });
                _context3.next = 3;
                return this.load();

              case 3:
                e = this._getHelperServiceUrl("geometry");
                0;
                _context3.next = 7;
                return import("../tasks/GeometryService.js");

              case 7:
                _context3.t0 = _context3.sent.default;
                _context3.t1 = {
                  url: e
                };
                return _context3.abrupt("return", new _context3.t0(_context3.t1));

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function createGeometryService() {
        return _createGeometryService.apply(this, arguments);
      }

      return createGeometryService;
    }()
  }, {
    key: "createPrintTask",
    value: function () {
      var _createPrintTask = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var e;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                i(u.getLogger(this.declaredClass), null, {
                  replacement: "Use helperServices url with esri/rest/print",
                  version: "4.21"
                });
                _context4.next = 3;
                return this.load();

              case 3:
                e = this._getHelperServiceUrl("printTask");
                0;
                _context4.next = 7;
                return import("../tasks/PrintTask.js");

              case 7:
                _context4.t0 = _context4.sent.default;
                _context4.t1 = e;
                return _context4.abrupt("return", new _context4.t0(_context4.t1));

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function createPrintTask() {
        return _createPrintTask.apply(this, arguments);
      }

      return createPrintTask;
    }()
  }, {
    key: "createRouteTask",
    value: function () {
      var _createRouteTask = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var e;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                i(u.getLogger(this.declaredClass), null, {
                  replacement: "Use helperServices url with esri/rest/route",
                  version: "4.21"
                });
                _context5.next = 3;
                return this.load();

              case 3:
                e = this._getHelperServiceUrl("route");
                0;
                _context5.next = 7;
                return import("../tasks/RouteTask.js");

              case 7:
                _context5.t0 = _context5.sent.default;
                _context5.t1 = e;
                return _context5.abrupt("return", new _context5.t0(_context5.t1));

              case 10:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function createRouteTask() {
        return _createRouteTask.apply(this, arguments);
      }

      return createRouteTask;
    }()
  }, {
    key: "createServiceAreaTask",
    value: function () {
      var _createServiceAreaTask = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var e;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                i(u.getLogger(this.declaredClass), null, {
                  replacement: "Use helperServices url with esri/rest/serviceArea",
                  version: "4.21"
                });
                _context6.next = 3;
                return this.load();

              case 3:
                e = this._getHelperServiceUrl("serviceArea");
                0;
                _context6.next = 7;
                return import("../tasks/ServiceAreaTask.js");

              case 7:
                _context6.t0 = _context6.sent.default;
                _context6.t1 = e;
                return _context6.abrupt("return", new _context6.t0(_context6.t1));

              case 10:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function createServiceAreaTask() {
        return _createServiceAreaTask.apply(this, arguments);
      }

      return createServiceAreaTask;
    }()
  }, {
    key: "fetchBasemaps",
    value: function fetchBasemaps(e, r) {
      var o = new _();
      return o.query = e || (t.apiKey && U(this.url) ? this.devBasemapGalleryGroupQuery : this.useVectorBasemaps ? this.vectorBasemapGalleryGroupQuery : this.basemapGalleryGroupQuery), o.disableExtraQuery = !0, this.queryGroups(o, r).then(function (e) {
        if (o.num = 100, o.query = 'type:"Web Map" -type:"Web Application"', e.total) {
          var _t2 = e.results[0];
          return o.sortField = _t2.sortField || "name", o.sortOrder = _t2.sortOrder || "desc", _t2.queryItems(o, r);
        }

        return null;
      }).then(function (e) {
        var t;
        return t = e && e.total ? e.results.filter(function (e) {
          return "Web Map" === e.type;
        }).map(function (e) {
          return new j({
            portalItem: e
          });
        }) : [], t;
      });
    }
  }, {
    key: "fetchCategorySchema",
    value: function fetchCategorySchema(e) {
      return this.hasCategorySchema ? this._request(this.restUrl + "/portals/self/categorySchema", e).then(function (e) {
        return e.categorySchema;
      }) : h(e) ? Promise.reject(c()) : Promise.resolve([]);
    }
  }, {
    key: "fetchFeaturedGroups",
    value: function fetchFeaturedGroups(e) {
      var t = this.featuredGroups,
          r = new _();

      if (r.num = 100, r.sortField = "title", t && t.length) {
        var _o = [];

        var _iterator2 = _createForOfIteratorHelper(t),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _e2 = _step2.value;

            _o.push("(title:\"".concat(_e2.title, "\" AND owner:").concat(_e2.owner, ")"));
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        return r.query = _o.join(" OR "), this.queryGroups(r, e).then(function (e) {
          return e.results;
        });
      }

      return h(e) ? Promise.reject(c()) : Promise.resolve([]);
    }
  }, {
    key: "fetchRegions",
    value: function fetchRegions(e) {
      var t = this.user && this.user.culture || this.culture || P();
      return this._request(this.restUrl + "/portals/regions", _objectSpread(_objectSpread({}, e), {}, {
        query: {
          culture: t
        }
      }));
    }
  }, {
    key: "queryGroups",
    value: function queryGroups(e, t) {
      return this._queryPortal("/community/groups", e, "PortalGroup", t);
    }
  }, {
    key: "queryItems",
    value: function queryItems(e, t) {
      return this._queryPortal("/search", e, "PortalItem", t);
    }
  }, {
    key: "queryUsers",
    value: function queryUsers(e, t) {
      return e.sortField || (e.sortField = "username"), this._queryPortal("/community/users", e, "PortalUser", t);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      throw new a("internal:not-yet-implemented", "Portal.toJSON is not yet implemented");
    }
  }, {
    key: "_getHelperService",
    value: function _getHelperService(e) {
      var t = this.helperServices && this.helperServices[e];
      if (!t) throw new a("portal:service-not-found", "The `helperServices` do not include an entry named \"".concat(e, "\""));
      return t;
    }
  }, {
    key: "_getHelperServiceUrl",
    value: function _getHelperServiceUrl(e) {
      var t = this._getHelperService(e);

      if (!t.url) throw new a("portal:service-url-not-found", "The `helperServices` entry \"".concat(e, "\" does not include a `url` value"));
      return t.url;
    }
  }, {
    key: "_fetchSelf",
    value: function _fetchSelf() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.authMode;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var r = arguments.length > 2 ? arguments[2] : undefined;

      var o = this.restUrl + "/portals/self",
          s = _objectSpread({
        authMode: e,
        query: {
          culture: P().toLowerCase()
        }
      }, r);

      return "auto" === s.authMode && (s.authMode = "no-prompt"), t && (s.query.default = !0), this._request(o, s);
    }
  }, {
    key: "_queryPortal",
    value: function _queryPortal(e, t, r, o) {
      var _this3 = this;

      var s = v(_, t),
          i = function i(t) {
        return _this3._request(_this3.restUrl + e, _objectSpread(_objectSpread({}, s.toRequestOptions(_this3)), o)).then(function (e) {
          var r = s.clone();
          return r.start = e.nextStart, new G({
            nextQueryParams: r,
            queryParams: s,
            total: e.total,
            results: _w._resultsToTypedArray(t, {
              portal: _this3
            }, e, o)
          });
        }).then(function (e) {
          return Promise.all(e.results.map(function (t) {
            return "function" == typeof t.when ? t.when() : e;
          })).then(function () {
            return e;
          }, function (t) {
            return y(t), e;
          });
        });
      };

      return r && Q[r] ? Q[r]().then(function (_ref2) {
        var e = _ref2.default;
        return d(o), i(e);
      }) : i();
    }
  }, {
    key: "_signIn",
    value: function _signIn() {
      var _this4 = this;

      if (this.authMode === _w.AUTH_MODE_ANONYMOUS) return Promise.reject(new a("portal:invalid-auth-mode", "Current \"authMode\"' is \"".concat(this.authMode, "\"")));
      if ("failed" === this.loadStatus) return Promise.reject(this.loadError);

      var e = function e(_e3) {
        return Promise.resolve().then(function () {
          return "not-loaded" === _this4.loadStatus ? (_e3 || (_this4.authMode = "immediate"), _this4.load().then(function () {
            return null;
          })) : "loading" === _this4.loadStatus ? _this4.load().then(function () {
            return _this4.credential ? null : (_this4.credential = _e3, _this4._fetchSelf("immediate"));
          }) : _this4.user && _this4.credential === _e3 ? null : (_this4.credential = _e3, _this4._fetchSelf("immediate"));
        }).then(function (e) {
          e && (_this4.sourceJSON = e, _this4.read(e));
        });
      };

      return r ? r.getCredential(this.restUrl).then(function (t) {
        return e(t);
      }) : e(this.credential);
    }
  }, {
    key: "_normalizeSSL",
    value: function _normalizeSSL(e) {
      return e.replace(/^http:/i, "https:").replace(":7080", ":7443");
    }
  }, {
    key: "_normalizeUrl",
    value: function _normalizeUrl(e) {
      var t = this.credential && this.credential.token;
      return this._normalizeSSL(t ? e + (e.indexOf("?") > -1 ? "&" : "?") + "token=" + t : e);
    }
  }, {
    key: "_requestToTypedArray",
    value: function _requestToTypedArray(e, t, r) {
      var _this5 = this;

      return this._request(e, t).then(function (e) {
        var t = _w._resultsToTypedArray(r, {
          portal: _this5
        }, e);

        return Promise.all(t.map(function (t) {
          return "function" == typeof t.when ? t.when() : e;
        })).then(function () {
          return t;
        }, function () {
          return t;
        });
      });
    }
  }, {
    key: "_readBasemap",
    value: function _readBasemap(e) {
      if (e) {
        var _t3 = j.fromJSON(e);

        return _t3.portalItem = {
          portal: this
        }, _t3;
      }

      return null;
    }
  }, {
    key: "_request",
    value: function _request(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var r = _objectSpread({
        f: "json"
      }, t.query),
          _t$authMode = t.authMode,
          s = _t$authMode === void 0 ? this.authMode === _w.AUTH_MODE_ANONYMOUS ? "anonymous" : "auto" : _t$authMode,
          _t$body = t.body,
          i = _t$body === void 0 ? null : _t$body,
          _t$cacheBust = t.cacheBust,
          a = _t$cacheBust === void 0 ? !1 : _t$cacheBust,
          _t$method = t.method,
          l = _t$method === void 0 ? "auto" : _t$method,
          _t$responseType = t.responseType,
          n = _t$responseType === void 0 ? "json" : _t$responseType,
          u = t.signal,
          p = {
        authMode: s,
        body: i,
        cacheBust: a,
        method: l,
        query: r,
        responseType: n,
        timeout: 0,
        signal: u
      };

      return o(this._normalizeSSL(e), p).then(function (e) {
        return e.data;
      });
    }
  }], [{
    key: "getDefault",
    value: function getDefault() {
      return _w._default && !_w._default.destroyed || (_w._default = new _w()), _w._default;
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(e) {
      if (!e) return null;
      if (e.declaredClass) throw new Error("JSON object is already hydrated");
      return new _w({
        sourceJSON: e
      });
    }
  }, {
    key: "_resultsToTypedArray",
    value: function _resultsToTypedArray(e, t, r, o) {
      var s;

      if (r) {
        var _i = p(o) ? o.signal : null;

        s = r.listings || r.notifications || r.userInvitations || r.tags || r.items || r.groups || r.comments || r.provisions || r.results || r.relatedItems || r, (e || t) && (s = s.map(function (r) {
          var o = Object.assign(e ? e.fromJSON(r) : r, t);
          return "function" == typeof o.load && o.load(_i), o;
        }));
      } else s = [];

      return s;
    }
  }]);

  return w;
}(l(n));

C.AUTH_MODE_ANONYMOUS = "anonymous", C.AUTH_MODE_AUTO = "auto", C.AUTH_MODE_IMMEDIATE = "immediate", e([m()], C.prototype, "access", void 0), e([m()], C.prototype, "allSSL", void 0), e([m()], C.prototype, "authMode", void 0), e([m()], C.prototype, "authorizedCrossOriginDomains", void 0), e([f("authorizedCrossOriginDomains")], C.prototype, "readAuthorizedCrossOriginDomains", null), e([m()], C.prototype, "basemapGalleryGroupQuery", void 0), e([m()], C.prototype, "bingKey", void 0), e([m()], C.prototype, "canListApps", void 0), e([m()], C.prototype, "canListData", void 0), e([m()], C.prototype, "canListPreProvisionedItems", void 0), e([m()], C.prototype, "canProvisionDirectPurchase", void 0), e([m()], C.prototype, "canSearchPublic", void 0), e([m()], C.prototype, "canShareBingPublic", void 0), e([m()], C.prototype, "canSharePublic", void 0), e([m()], C.prototype, "canSignInArcGIS", void 0), e([m()], C.prototype, "canSignInIDP", void 0), e([m()], C.prototype, "colorSetsGroupQuery", void 0), e([m()], C.prototype, "commentsEnabled", void 0), e([m({
  type: Date
})], C.prototype, "created", void 0), e([m()], C.prototype, "credential", void 0), e([m()], C.prototype, "culture", void 0), e([m()], C.prototype, "currentVersion", void 0), e([m()], C.prototype, "customBaseUrl", void 0), e([m()], C.prototype, "defaultBasemap", void 0), e([f("defaultBasemap")], C.prototype, "readDefaultBasemap", null), e([m()], C.prototype, "defaultDevBasemap", void 0), e([f("defaultDevBasemap")], C.prototype, "readDefaultDevBasemap", null), e([m({
  type: g
})], C.prototype, "defaultExtent", void 0), e([m()], C.prototype, "defaultVectorBasemap", void 0), e([f("defaultVectorBasemap")], C.prototype, "readDefaultVectorBasemap", null), e([m()], C.prototype, "description", void 0), e([m()], C.prototype, "devBasemapGalleryGroupQuery", void 0), e([m()], C.prototype, "eueiEnabled", void 0), e([m({
  readOnly: !0
})], C.prototype, "extraQuery", null), e([m()], C.prototype, "featuredGroups", void 0), e([m()], C.prototype, "featuredItemsGroupQuery", void 0), e([m()], C.prototype, "galleryTemplatesGroupQuery", void 0), e([m()], C.prototype, "livingAtlasGroupQuery", void 0), e([m()], C.prototype, "hasCategorySchema", void 0), e([m()], C.prototype, "helpBase", void 0), e([m()], C.prototype, "helperServices", void 0), e([m()], C.prototype, "helpMap", void 0), e([m()], C.prototype, "homePageFeaturedContent", void 0), e([m()], C.prototype, "homePageFeaturedContentCount", void 0), e([m()], C.prototype, "httpPort", void 0), e([m()], C.prototype, "httpsPort", void 0), e([m()], C.prototype, "id", void 0), e([m()], C.prototype, "ipCntryCode", void 0), e([m({
  readOnly: !0
})], C.prototype, "isOrganization", null), e([m()], C.prototype, "isPortal", void 0), e([m()], C.prototype, "isReadOnly", void 0), e([m()], C.prototype, "layerTemplatesGroupQuery", void 0), e([m()], C.prototype, "maxTokenExpirationMinutes", void 0), e([m({
  type: Date
})], C.prototype, "modified", void 0), e([m()], C.prototype, "name", void 0), e([m()], C.prototype, "portalHostname", void 0), e([m()], C.prototype, "portalMode", void 0), e([m()], C.prototype, "portalProperties", void 0), e([m()], C.prototype, "region", void 0), e([m({
  readOnly: !0
})], C.prototype, "restUrl", null), e([m()], C.prototype, "rotatorPanels", void 0), e([m()], C.prototype, "showHomePageDescription", void 0), e([m()], C.prototype, "sourceJSON", void 0), e([m()], C.prototype, "staticImagesUrl", void 0), e([m({
  readOnly: !0,
  json: {
    read: !1
  }
})], C.prototype, "stylesGroupQuery", null), e([m({
  json: {
    name: "2DStylesGroupQuery"
  }
})], C.prototype, "stylesGroupQuery2d", void 0), e([m({
  json: {
    name: "stylesGroupQuery"
  }
})], C.prototype, "stylesGroupQuery3d", void 0), e([m()], C.prototype, "supportsHostedServices", void 0), e([m()], C.prototype, "symbolSetsGroupQuery", void 0), e([m()], C.prototype, "templatesGroupQuery", void 0), e([m()], C.prototype, "thumbnail", void 0), e([m({
  readOnly: !0
})], C.prototype, "thumbnailUrl", null), e([m()], C.prototype, "units", void 0), e([m()], C.prototype, "url", void 0), e([m()], C.prototype, "urlKey", void 0), e([f("urlKey")], C.prototype, "readUrlKey", null), e([m()], C.prototype, "user", void 0), e([f("user")], C.prototype, "readUser", null), e([m()], C.prototype, "useStandardizedQuery", void 0), e([m()], C.prototype, "useVectorBasemaps", void 0), e([m()], C.prototype, "vectorBasemapGalleryGroupQuery", void 0), C = _w = e([S("esri.portal.Portal")], C);
var B = C;
export { B as default };